// src/components/TopBar.jsx
// Barra superior que muestra título de página y acciones
import React from "react";
import { useLocation, Link } from "react-router-dom";

const TITULOS = {
  "/":              { titulo:"Panel general",       accion:null },
  "/midia":         { titulo:"Mi día",              accion:null },
  "/clientes":      { titulo:"Clientes",            accion:{ label:"+ Nuevo cliente", to:"/clientes/nuevo" } },
  "/cotizaciones":  { titulo:"Cotizaciones",        accion:null },
  "/pedidos":       { titulo:"Pedidos",             accion:null },
  "/seguimiento":   { titulo:"Seguimiento",         accion:null },
  "/pipeline":      { titulo:"Embudo de ventas",    accion:null },
  "/transporte":    { titulo:"Transporte y flota",  accion:null },
  "/proveedores":   { titulo:"Proveedores",         accion:null },
  "/reportes":      { titulo:"Reportes",            accion:null },
  "/usuarios":      { titulo:"Gestión de usuarios", accion:null },
};

function fechaHoy() {
  return new Date().toLocaleDateString("es-PE", {
    weekday:"long", day:"numeric", month:"long", year:"numeric"
  });
}

export default function TopBar() {
  const { pathname } = useLocation();
  const info = TITULOS[pathname] || { titulo:"PROVEXO+", accion:null };

  return (
    <div style={{
      background:"#fff",
      borderBottom:"0.5px solid #e2e8f0",
      padding:"0 24px",
      height:52,
      display:"flex",
      alignItems:"center",
      justifyContent:"space-between",
      flexShrink:0,
    }}>
      <div>
        <h1 style={{ fontSize:16, fontWeight:700, color:"#1e293b", margin:0 }}>
          {info.titulo}
        </h1>
        <div style={{ fontSize:10, color:"#94a3b8", marginTop:1, textTransform:"capitalize" }}>
          {fechaHoy()}
        </div>
      </div>
      {info.accion && (
        <Link to={info.accion.to} style={{
          background:"#F97316", color:"#000",
          textDecoration:"none", borderRadius:7,
          padding:"7px 16px", fontSize:12, fontWeight:700,
          transition:"opacity 150ms ease-out, transform 160ms ease-out",
          display:"inline-block",
        }}
        onMouseEnter={e => { e.currentTarget.style.opacity="0.88"; }}
        onMouseLeave={e => { e.currentTarget.style.opacity="1"; }}
        onMouseDown={e  => { e.currentTarget.style.transform="scale(0.97)"; }}
        onMouseUp={e    => { e.currentTarget.style.transform="scale(1)"; }}
        >
          {info.accion.label}
        </Link>
      )}
    </div>
  );
}
